module.exports = __webpack_public_path__ + "img/beta-tile-mobile.fa51398.jpg";